import { useNumistaStatus } from '@numistic/data'
import { useTranslation } from '@numistic/i18n'
import { createRoute, Link, Outlet } from '@tanstack/react-router'

import { monthName } from '../../lib/format.js'
import { requireRole } from '../../lib/guards.js'
import { rootRoute } from '../root.js'

export const adminRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin',
  beforeLoad: ({ context, location }) => requireRole(context, location, 'admin'),
  component: AdminLayout,
})

function AdminLayout() {
  const { t } = useTranslation()
  const tab =
    'border-b-2 border-transparent px-1 pb-2 text-sm text-muted-foreground hover:text-foreground [&.active]:border-primary [&.active]:text-foreground'
  return (
    <div className="grid gap-6">
      <nav className="flex gap-6 border-b">
        <Link to="/admin/users" className={tab}>
          {t('admin.usersTitle')}
        </Link>
        <Link to="/admin/invites" className={tab}>
          {t('admin.invitesTitle')}
        </Link>
        <Link to="/admin/references" search={{ kind: 'issuers' }} className={tab}>
          {t('admin.referencesTitle')}
        </Link>
        <Link to="/admin/meta" search={{}} className={tab}>
          {t('admin.metaTitle')}
        </Link>
        <Link to="/admin/changes" className={tab}>
          {t('admin.changesTitle')}
        </Link>
        <Link to="/admin/types" search={{}} className={tab}>
          {t('admin.typesTitle')}
        </Link>
      </nav>
      <NumistaQuota />
      <Outlet />
    </div>
  )
}

/** Расход месячной квоты Numista API (docs/PLAN.md, этап 1.6). */
function NumistaQuota() {
  const { t } = useTranslation()
  const status = useNumistaStatus().data
  if (!status) return null
  return (
    <p className="-mt-3 text-xs text-muted-foreground" data-testid="numista-quota">
      {status.configured
        ? t('numista.quota', {
            used: status.used,
            quota: status.quota,
            month: monthName(status.month),
          })
        : t('numista.notConfigured')}
    </p>
  )
}
